import _ from 'lodash'
import { twMerge } from 'tailwind-merge'
import { Api, lookup } from '@cruz-com/lookup'
import { Separator, RadioButtons } from '@/components'
import { abbNumber } from '@/lib'

type Props = {
  meta: Api.Meta
  pageSize?: number
  className?: string
  onPageSizeChanged?: (val: any) => void
} & ((React.ComponentPropsWithoutRef<'span'>))

export function PageMeta({ meta, pageSize, className, onPageSizeChanged }: Props) {
  if (_.isEmpty(meta) || !meta.total_records_matched) {
    return <div />
  }

  const start = ((meta?.page_number || 1) - 1) * (meta?.page_size || 12) + 1
  const end = Math.min(meta?.total_records_matched || 0, start - 1 + (meta?.page_size || 12))
  return (
    <div className='flex flex-col sm:flex-row sm:items-center gap-3'>
      <div className={twMerge(
        'flex gap-x-1 font-light text-base/6 md:text-sm/6 py-1',
        className,
      )}>
        Showing
        <span className='font-medium'>{start.toLocaleString()}</span>
        to
        <span className='font-medium'>{end.toLocaleString()}</span>
        of
        <span className='font-medium'>{abbNumber(meta?.total_records_matched, 2)}</span>
        results
      </div>
      {
        (pageSize && onPageSizeChanged) &&
        <>
          <Separator className='hidden sm:block' />
          <div className='flex items-center gap-x-3'>
            <div className='vehicle-s2-label'>Page Size:</div>
            <RadioButtons name='page_size' option={lookup.other.pageSizeOption}
              value={_.toNumber(pageSize)}
              onChange={val => { onPageSizeChanged(val) }}
            />
          </div>
        </>
      }
    </div>
  )
}

